var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-image',{style:({ width: _vm.width, height: _vm.height }),attrs:{"src":_vm.getImage(_vm.type),"fit":"fit"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }